<template>
  <simplebar data-simplebar-auto-hide="false">
    <ul class="event-popular-services__list">
      <li v-for="(item, i) in list" :key="i">
        <a
          @click.prevent="showService(item)"
          href="#"
          class="event-popular-services__item"
          :class="{
            'event-popular-services__item--white': white,
            'event-popular-services__item--icon': item.icon
          }"
        >
          <icon
            :name="item.icon"
            v-if="item.icon"
            class="event-popular-services__item-icon"
          />
          <div class="event-popular-services__item-info">
            <h4 class="event-popular-services__item-title">
              {{ item | localeField("name") }}
            </h4>
            <span class="event-popular-services__item-price">
              <span>
                {{ getPrice(item.prices) | formatPrice }} {{ currency?.symbol }}
              </span>
              / {{ getUnit(item.prices) }}
            </span>
          </div>
        </a>
      </li>
    </ul>
  </simplebar>
</template>

<script>
import { i18n } from "@v2/shared/config";
import { mapGetters } from "vuex";
export default {
  name: "EventPopularServicesList",
  props: {
    list: Array,
    opened: {
      type: Boolean,
      default: false
    },
    closeId: {
      type: Number
    },
    white: Boolean,
    parentId: {
      type: Number,
      default: null
    }
  },

  computed: {
    ...mapGetters("event", ["currency"])
  },
  methods: {
    getPrice(prices) {
      const currentPrice = prices.find(
        price => price.currency === this.currency?.code
      );
      return currentPrice ? Number(currentPrice.price_with_vat) : "N/A";
    },
    getUnit(prices) {
      const currentPrice = prices.find(
        price => price.currency === this.currency?.code
      );
      if (!currentPrice) return "";

      return i18n.locale === "en"
        ? currentPrice.unit.name_eng
        : currentPrice.unit.name_rus;
    },
    showService(service) {
      if (this.parentId) {
        this.$modal.hide("service-modal", { id: this.parentId });
      }
      this.$modal.show("service-modal", { id: service.id });
    }
  }
};
</script>

<style lang="scss">
@import "@v2/app/styles/mixins";
@import "@v2/app/styles/media";

.event-popular-services {
  * {
    box-sizing: border-box;
  }

  &__list {
    max-width: calc(100vw - 30px);
    width: 100%;
    margin: 0 -30px 10px 0;
    padding: 0 30px 10px 0;
    list-style: none;
    display: flex;
    @media (max-width: 740px) {
      margin: 0 -20px 0 0;
      padding: 0 20px 10px 0;
    }

    li {
      width: 210px;
      min-height: 174px;
      flex-shrink: 0;

      &:not(:last-child) {
        margin-right: 15px;
      }
    }
  }

  &__item {
    max-width: 250px;
    display: flex;
    height: 100%;
    max-height: 100%;
    padding: 15px;
    border: 1px solid var(--gray-darker, #d5dae5);
    box-sizing: border-box;
    text-decoration: none;
    font-size: 0.75rem;
    line-height: 1.5;
    color: var(--dark-light, #6d7179);

    transition: border-color var(--transition, 0.2s);

    &--white {
      background: var(--white);
    }

    &--icon {
      border-width: 2px;
      border-color: var(--main-dark);
    }

    &:hover {
      border-color: var(--main-dark);
    }

    &-icon {
      margin-top: 2px;
      width: 20px;
      height: 20px;
      margin-right: 10px;
      flex-shrink: 0;
    }

    &-info {
      display: flex;
      flex-direction: column;

      > *:not(:last-child) {
        margin-bottom: 5px;
      }
    }

    &-title {
      display: -webkit-box;
      font-size: 14px;
      font-weight: 700;
      line-height: 1.57;
      color: #262626;
      margin: 0;
      overflow: hidden;
      -webkit-line-clamp: 7;
      -webkit-box-orient: vertical;

      @media (max-width: 740px) {
        font-size: 12px;
      }
    }

    &-description {
      flex-grow: 1;
    }

    &-price {
      margin-top: auto;
      color: #a3a8b3;

      span {
        font-weight: 700;
        color: #005197;
      }
    }
  }
}
.services-list-table {
  &__popular-list {
    & .event-popular-services__item-title {
      font-weight: 400;
    }
  }
}
</style>
